<template>
    <div class="week-snapshot">
        <h2>By the Numbers</h2>
        <div class="table week-snapshot-full-table" v-if="!showSwiper">
            <div class="header">
                <div class="header-cell text-center cell"></div>
                <div class="header-cell text-center cell-medium">Gross</div>
                <div class="header-cell text-center">Gross Pot. %</div>
                <div class="header-cell text-center">Attendance</div>
                <div class="header-cell text-center">Cap. %</div>
                <div class="header-cell text-center">No. of Shows</div>
                <div class="header-cell text-center">Avg. Ticket</div>
                <div class="header-cell text-center">Perf. (Prev.)</div>
            </div>
            <div class="body">
                <div
                    class="row"
                    :class="`row-${set.class}`"
                    v-for="set in weekSets"
                    :key="set.label"
                >
                    <div class="cell week-snapshot-row-label text-right cell">
                        {{ set.label }}
                    </div>

                    <div class="cell text-center cell-medium">
                        {{ (set.gross / 100) | moneyRounded }}
                        <diff-indicator
                            v-if="typeof set.diffs.gross !== 'undefined'"
                            :primary="set.diffs.gross / 100"
                            primary-filter="moneyRounded"
                        />
                    </div>

                    <div
                        class="cell text-center"
                        v-if="set.gross_potential_percentage > 0"
                    >
                        {{ set.gross_potential_percentage / 100 }}%
                        <diff-indicator
                            v-if="typeof set.diffs.gross !== 'undefined'"
                            :primary="
                                set.diffs.gross_potential_percentage / 100
                            "
                            primary-filter="percentage"
                        />
                    </div>
                    <div class="cell text-center" v-else>
                        &mdash;
                    </div>

                    <div class="cell text-center">
                        {{ set.attendance | commaNumber }}
                        <diff-indicator
                            v-if="typeof set.diffs.attendance !== 'undefined'"
                            :primary="set.diffs.attendance"
                            primary-filter="commaNumber"
                        />
                    </div>

                    <div class="cell text-center">
                        {{ set.capacity_percentage / 100 }}%
                        <diff-indicator
                            v-if="typeof set.diffs.attendance !== 'undefined'"
                            :primary="set.diffs.capacity_percentage / 100"
                            primary-filter="percentage"
                        />
                    </div>

                    <div class="cell text-center">
                        {{ set.shows | commaNumber }}
                        <diff-indicator
                            v-if="typeof set.diffs.shows !== 'undefined'"
                            :primary="set.diffs.shows"
                            primary-filter="commaNumber"
                        />
                    </div>

                    <div class="cell text-center" v-if="set.ticket_average > 0">
                        {{ (set.ticket_average / 100) | money }}
                        <diff-indicator
                            v-if="
                                typeof set.diffs.ticket_average !== 'undefined'
                            "
                            :primary="set.diffs.ticket_average / 100"
                            primary-filter="money"
                        />
                    </div>
                    <div class="cell text-center" v-else>
                        &mdash;
                    </div>

                    <div class="cell text-center">
                        {{ set.performances || 0 | commaNumber }} ({{
                            set.previews || 0 | commaNumber
                        }})
                        <diff-indicator
                            v-if="typeof set.diffs.performances !== 'undefined'"
                            :primary="set.diffs.performances"
                            primary-filter="commaNumber"
                            :secondary="set.diffs.previews"
                            secondary-filter="commaNumber"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="week-snapshot-slider-wrapper" v-if="showSwiper">
            <div class="table">
                <div class="body">
                    <div
                        class="row"
                        :class="`row-${set.class}`"
                        v-for="set in weekSets"
                        :key="set.label"
                    >
                        <div class="cell week-snapshot-row-label text-right">
                            {{ set.label }}
                        </div>
                    </div>
                </div>
            </div>
            <swiper
                :paginate="true"
                :centered-slides="false"
                :swiper-config="swiperConfig"
            >
                <swiper-slide>
                    <div class="table">
                        <div class="header">
                            <div class="header-cell text-center">Gross</div>
                        </div>
                        <div class="body">
                            <div
                                class="row"
                                :class="`row-${set.class}`"
                                v-for="set in weekSets"
                                :key="set.label"
                            >
                                <div class="cell text-center">
                                    {{ (set.gross / 100) | moneyRounded }}
                                    <diff-indicator
                                        v-if="
                                            typeof set.diffs.gross !==
                                                'undefined'
                                        "
                                        :primary="set.diffs.gross / 100"
                                        primary-filter="moneyRounded"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="table">
                        <div class="header">
                            <div class="header-cell text-center">
                                Gross Pot. %
                            </div>
                        </div>
                        <div class="body">
                            <div
                                class="row"
                                :class="`row-${set.class}`"
                                v-for="set in weekSets"
                                :key="set.label"
                            >
                                <div
                                    class="cell text-center"
                                    v-if="set.gross_potential_percentage > 0"
                                >
                                    {{ set.gross_potential_percentage / 100 }}%
                                    <diff-indicator
                                        v-if="
                                            typeof set.diffs.gross !==
                                                'undefined'
                                        "
                                        :primary="
                                            set.diffs
                                                .gross_potential_percentage /
                                                100
                                        "
                                        primary-filter="percentage"
                                    />
                                </div>
                                <div class="cell text-center" v-else>
                                    &mdash;
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="table">
                        <div class="header">
                            <div class="header-cell text-center">
                                Attendance
                            </div>
                        </div>
                        <div class="body">
                            <div
                                class="row"
                                :class="`row-${set.class}`"
                                v-for="set in weekSets"
                                :key="set.label"
                            >
                                <div class="cell text-center">
                                    {{ set.attendance | commaNumber }}
                                    <diff-indicator
                                        v-if="
                                            typeof set.diffs.attendance !==
                                                'undefined'
                                        "
                                        :primary="set.diffs.attendance"
                                        primary-filter="commaNumber"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="table">
                        <div class="header">
                            <div class="header-cell text-center">Cap. %</div>
                        </div>
                        <div class="body">
                            <div
                                class="row"
                                :class="`row-${set.class}`"
                                v-for="set in weekSets"
                                :key="set.label"
                            >
                                <div class="cell text-center">
                                    {{ set.capacity_percentage / 100 }}%
                                    <diff-indicator
                                        v-if="
                                            typeof set.diffs.attendance !==
                                                'undefined'
                                        "
                                        :primary="
                                            set.diffs.capacity_percentage / 100
                                        "
                                        primary-filter="percentage"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="table">
                        <div class="header">
                            <div class="header-cell text-center">
                                No. of Shows
                            </div>
                        </div>
                        <div class="body">
                            <div
                                class="row"
                                :class="`row-${set.class}`"
                                v-for="set in weekSets"
                                :key="set.label"
                            >
                                <div class="cell text-center">
                                    {{ set.shows | commaNumber }}
                                    <diff-indicator
                                        v-if="
                                            typeof set.diffs.shows !==
                                                'undefined'
                                        "
                                        :primary="set.diffs.shows"
                                        primary-filter="commaNumber"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="table">
                        <div class="header">
                            <div class="header-cell text-center">
                                Avg. Ticket
                            </div>
                        </div>
                        <div class="body">
                            <div
                                class="row"
                                :class="`row-${set.class}`"
                                v-for="set in weekSets"
                                :key="set.label"
                            >
                                <div
                                    class="cell text-center"
                                    v-if="set.ticket_average > 0"
                                >
                                    {{ (set.ticket_average / 100) | money }}
                                    <diff-indicator
                                        v-if="
                                            typeof set.diffs.ticket_average !==
                                                'undefined'
                                        "
                                        :primary="
                                            set.diffs.ticket_average / 100
                                        "
                                        primary-filter="money"
                                    />
                                </div>
                                <div class="cell text-center" v-else>
                                    &mdash;
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="table">
                        <div class="header">
                            <div class="header-cell text-center">
                                Perf. (Prev.)
                            </div>
                        </div>
                        <div class="body">
                            <div
                                class="row"
                                :class="`row-${set.class}`"
                                v-for="set in weekSets"
                                :key="set.label"
                            >
                                <div class="cell text-center">
                                    {{ set.performances || 0 | commaNumber }}
                                    ({{ set.previews || 0 | commaNumber }})
                                    <diff-indicator
                                        v-if="
                                            typeof set.diffs.performances !==
                                                'undefined'
                                        "
                                        :primary="set.diffs.performances"
                                        primary-filter="commaNumber"
                                        :secondary="set.diffs.previews"
                                        secondary-filter="commaNumber"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
import DiffIndicator from 'src/components/DiffIndicator';
import Swiper from 'src/components/Swiper';
import SwiperSlide from 'src/components/SwiperSlide';

export default {
    data() {
        return {
            periods: [
                {
                    key: 'this_week',
                    class: 'this-week',
                    label: 'This Week',
                },
                {
                    key: 'last_week',
                    class: 'last-week',
                    label: 'vs. Last Week',
                },
                //{
                //    key: 'last_season',
                //    class: 'last-season',
                //    label: 'vs. Last Season',
                //},
            ],
            showSwiper: false,
        };
    },
    components: {
        DiffIndicator,
        Swiper,
        SwiperSlide,
    },
    created() {
        const mediaQuery = window.matchMedia('(max-width: 1280px)');

        this.showSwiper = mediaQuery.matches;

        this.swiperSizeListener = event => {
            this.showSwiper = event.matches;
        };

        mediaQuery.addEventListener('change', this.swiperSizeListener);
    },
    destroyed() {
        mediaQuery.removeListener(this.swiperSizeListener);
    },
    computed: {
        week() {
            return this.$store.getters['week/current'];
        },
        weekSets() {
            return this.periods.map(set => ({
                ...set,
                ...this.week.stats[set.key],
                diffs: this.diffs(set),
            }));
        },
        swiperConfig() {
            if (this.$root.isMobile) {
                return {};
            }

            return {
                slidesPerView: 4,
                slidesPerGroup: 4,
                centeredSlides: false,
            };
        },
    },
    methods: {
        diffs(set) {
            if (set.key === 'this_week') {
                return {};
            }

            return [
                'attendance',
                'gross',
                'gross_potential_percentage',
                'performances',
                'previews',
                'ticket_average',
                'capacity_percentage',
                'shows',
            ].reduce((carry, current) => {
                carry[current] =
                    this.week.stats['this_week'][current] -
                    this.week.stats[set.key][current];

                return carry;
            }, {});
        },
    },
};
</script>
